import React from "react";
import "./OrderUser.css";
import Auth from "../Auth";

const OrderUser = () => {
    return (
        <>
            <Auth
                nextPage="/order-address-select" // Redirect to order-payment after successful authentication
                isRegisterPage={true} // Force registration flow
                title="Ваши данные" // Custom title for the Auth component
            />
        </>
    );
};

export default OrderUser;